import React, { useState } from 'react';
import * as organizationsAPI from '../../../api/organizationsAPI';
import { StatusPopup } from '../shared/StatusPopup';

const AttachOrganization = ({ organizations, currentUser }) => {
	const statusPopupObjectTemplate = {
		show: false,
		text: '',
		type: '',
	};

	const [showStatusPopupObject, setShowStatusPopupObject] = useState(false);
	const [statusPopupObject, setStatusPopupObject] = useState(
		statusPopupObjectTemplate
	);

	const handleConnect = () => {
		let orgID = document.getElementById('organization_ids_select').value;
		organizationsAPI.attachUser(currentUser.id, orgID).then((response) => {
			let tempShowStatusObject;
			if (response.status === 200) {
				redirectToOrgPage(orgID);
			} else {
				tempShowStatusObject = {
					type: 'failed',
					text: 'Failed to connect to organization. Please try again.',
				};
				setStatusPopupObject(tempShowStatusObject);
				setShowStatusPopupObject(true);
			}
		});
	};

	const redirectToNewOrgPage = () => {
		location.assign('/organizations/new');
	};

	const redirectToNewOrgPageCreator = () => {
		location.assign('/organizations/new?kind=Creator');
	};

	/**
	 * Redirects to the org page, and tells the org to display a successful status popup on page load
	 */
	const redirectToOrgPage = (orgID) => {
		location.assign(`/organizations/${orgID}?attach=true`);
	};

	return (
		<div className="attach-org-container">
			{showStatusPopupObject ? (
				<StatusPopup
					statusPopupObject={statusPopupObject}
					setShowStatusPopup={setShowStatusPopupObject}
				/>
			) : (
				''
			)}

			<h2>Attach your profile to an organization or create your own</h2>
			<h3>
				If you represent an organization, you can search the directory
				to see if it is already set up.
			</h3>

			<select
				className="body-font"
				defaultValue=""
				name="organization_ids"
				id="organization_ids_select"
			>
				<option value="" disabled />
				{organizations.map((organization) => {
					return (
						<option key={organization[0]} value={organization[0]}>
							{organization[1]}
						</option>
					);
				})}
			</select>
			<div className="primary-button" onClick={handleConnect}>
				<p>Connect</p>
			</div>

			<h3>
				If you didn't find the organization above, you can create an
				organization here.
			</h3>
			<div className="secondary-button" onClick={redirectToNewOrgPage}>
				<p>Add New</p>
			</div>

			<h3>
				Are you a creator, athlete or influencer? Create a new
				organization to represent yourself.
			</h3>
			<div
				className="secondary-button"
				onClick={redirectToNewOrgPageCreator}
			>
				<p>Add New</p>
			</div>
		</div>
	);
};

export default AttachOrganization;
